<form
  class="flex w-full flex-col gap-4 px-8 py-8 sm:px-8 sm:py-9"
  #editBucketForm="ngForm"
  [formGroup]="formGroup"
  (ngSubmit)="editBucketFormSubmit(formGroup.getRawValue())"
  autocomplete="off"
>
  <header class="flex flex-col gap-1">
    <h3 class="text-base font-bold text-text-title">Budget settings</h3>
    <p class="text-sm text-text-secondary">
      Rename this budget, adjust the monthly amount, or archive it.
    </p>
  </header>

  <app-ui-field label="Budget name" [inputId]="'edit-bucket-name'">
    <input
      id="edit-bucket-name"
      appUiInput
      name="name"
      type="text"
      formControlName="name"
      maxlength="24"
      required
    />
  </app-ui-field>

  <!-- Transfers is system-managed (LCL-66): its type cannot change, so no selector. -->
  @if (bucket().type !== 'TRANSFERS') {
    <app-bucket-type-selector
      [type]="selectedType()"
      legend="Budget type"
      name="editBucketType"
      [disabled]="!canChangeType"
      (typeChange)="changeType($event)"
    />
    @if (!canChangeType && !bucket().archivedMonth) {
      <p class="m-0 text-sm text-text-secondary">
        Budget type is locked after the month it was created to protect your history.
        Create a new budget to use a different type.
      </p>
    }
  }

  <app-ui-field [label]="amountLabel()" [inputId]="'edit-bucket-amount'">
    <app-ui-currency-input
      inputId="edit-bucket-amount"
      name="amount"
      placeholder="0.00"
      formControlName="amount"
    />
  </app-ui-field>

  @if (showsGoal()) {
    <app-ui-field [label]="goalLabel()" [inputId]="'edit-bucket-goal'">
      <app-ui-currency-input
        inputId="edit-bucket-goal"
        name="goal"
        placeholder="0.00"
        formControlName="goal"
      />
    </app-ui-field>
  }

  @if (bucket().type !== 'TRANSFERS') {
    <details
      class="rounded-md border border-border px-4 py-2"
      [open]="bucket().excludedFromSpendingReports"
    >
      <summary class="cursor-pointer select-none text-sm font-bold text-text-title">Advanced settings</summary>
      <div class="pt-4">
        <app-ui-checkbox
          inputId="edit-bucket-exclude-from-spending-reports"
          labelId="edit-bucket-exclude-from-spending-reports-label"
          ariaDescribedBy="edit-bucket-exclude-from-spending-reports-description"
          name="excludedFromSpendingReports"
          formControlName="excludedFromSpendingReports"
        >
          Exclude from spending reports
        </app-ui-checkbox>
        <p
          id="edit-bucket-exclude-from-spending-reports-description"
          class="mt-1 pl-9 text-sm text-text-secondary"
        >
          Transactions stay categorized and visible, but stop counting toward spending totals and charts. The
          money still counts as available to spend and toward your monthly budget.
        </p>
      </div>
    </details>
  }

  <app-ui-save-button
    class="mt-1 self-stretch"
    [state]="saveButtonState"
    [disabled]="formGroup.disabled || formGroup.invalid || loading"
  />
  @if (saveError()) {
    <p class="m-0 text-sm font-semibold text-status-danger" aria-live="polite">
      {{ saveError() }}
    </p>
  }

  <!-- Archive/delete stay visible for TRANSFERS: the API protects the LAST active one,
       and duplicates must stay archivable so accounts converge to exactly-one. -->
  @if (!bucket().archivedMonth && (month.isThisMonthCurrent$ | async)) {
    @if (canDeleteBucket(bucket())) {
      <button
        appUiButton
        appearance="outline"
        tone="danger"
        type="button"
        class="mt-2 self-stretch"
        (click)="deleteBucket(bucket())"
      >
        Delete
      </button>
    }
    @if (!canDeleteBucket(bucket())) {
      <button
        appUiButton
        appearance="outline"
        tone="danger"
        type="button"
        class="mt-2 self-stretch"
        (click)="confirmArchiveBucket(bucket())"
      >
        Archive/Delete
      </button>
    }
  }
  @if (bucket().archivedMonth) {
    <button
      appUiButton
      appearance="outline"
      tone="danger"
      type="button"
      class="mt-2 self-stretch"
      (click)="unarchiveBucket(bucket())"
    >
      Unarchive
    </button>
  }
</form>
